import React from 'react'
import styled from '@emotion/styled'
import cn from 'classnames'
import themeVars from 'ui_theme/site/globals/site.variables'
import ReplyForm from 'components/App/DesktopView/ReplyForm'
import NavBar from 'components/App/DesktopView/shared/Composer/Email/Header/NavBar'
import { Flex } from 'shared/ui'
import withFocusing from './withFocusing'

const Replying = ({
  className,
  focused, // from withFocusing
  isForwarding,
  isOpen,
  onClick,
  onEditorBlur,
  onEditorFocus,
  ticketId,
}) => {
  return (
    <Flex
      className={cn('grui flex-col', className, {
        forwarding: isForwarding,
        focused,
      })}
      onClick={onClick}
    >
      <NavBar replying ticketId={ticketId} />
      <div css={{ marginTop: themeVars.small }}>
        <ReplyForm
          isOpen={isOpen}
          onEditorBlur={onEditorBlur}
          onEditorFocus={onEditorFocus}
          subjectPrefix={'Re:'}
          ticketId={ticketId}
        />
      </div>
    </Flex>
  )
}

export default styled(withFocusing(Replying))`
  background-color: ${props => props.theme.color.monochrome.white};
  border-radius: 4px;
  border: 1px solid ${props => props.theme.color.monochrome.medium};
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.05);
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  padding: ${props =>
    `${props.theme.spacing['4']} ${props.theme.spacing['10']}`};
  opacity: 1;
  visibility: visible;
  z-index: 100;

  &.forwarding {
    background-color: ${props => props.theme.color.secondary.positive};
  }

  &.focused {
    border-color: ${props => props.theme.color.primary.brand};
  }
`
